import { combineReducers } from "redux";

import { metronic } from "_metronic";

import { actionTypes as workspaceActionTypes } from "app/store/modules/actions/workspaces.actions";
import * as app from "app/store/modules/app.reducer";
import * as auth from "app/store/modules/auth.reducer";
import * as features from "app/store/modules/features.reducer";
import * as fileRenameJobs from "app/store/modules/file-rename-jobs.reducer";
import * as fileRenameRules from "app/store/modules/file-rename-rules.reducer";
import * as integrations from "app/store/modules/integrations.reducer";
import * as flags from "app/store/modules/loading-flag.reducer";
import * as notifications from "app/store/modules/notifications.reducer";
import * as notistack from "app/store/modules/notistack.reducer";
import * as provider from "app/store/modules/provider.reducer";
import * as requests from "app/store/modules/requests.reducer";
import * as tasks from "app/store/modules/tasks.reducer";
import * as team from "app/store/modules/team.reducer";
import * as templates from "app/store/modules/templates.reducer";
import * as workspaces from "app/store/modules/workspaces.reducer";

const combinedReducer = combineReducers({
  app: app.reducer,
  auth: auth.reducer,
  requests: requests.reducer,
  templates: templates.reducer,
  fileRenameRules: fileRenameRules.reducer,
  fileRenameJobs: fileRenameJobs.reducer,
  provider: provider.reducer,
  notifications: notifications.reducer,
  notistack: notistack.reducer,
  flags: flags.reducer,
  tasks: tasks.reducer,
  features: features.reducer,
  integrations: integrations.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  workspaces: workspaces.reducer,
  team: team.reducer,
});

export const rootReducer = (state, action) => {
  if (action.type === workspaceActionTypes.WORKSPACE_ACTIVE_CHANGED && state) {
    const scopedSliceKeys = new Set([
      "requests",
      "templates",
      "fileRenameRules",
      "fileRenameJobs",
      "integrations",
      "provider",
      "team",
    ]);
    const preserved = Object.fromEntries(
      Object.entries(state).filter(([key]) => !scopedSliceKeys.has(key))
    );
    return combinedReducer(preserved, action);
  }

  return combinedReducer(state, action);
};
